<template>
  <v-avatar
      v-bind="$attrs"
      :color="imageAvatar ? undefined : generateColorBasedOnId(value.id)"
  >
    <v-img v-if="imageAvatar" :src="imageUrl" alt="user-avatar"></v-img>
    <span
        v-else
        class="white--text"
        :style="`font-size: ${textSize}px !important`"
    >{{
        value.firstName ? value.firstName.charAt(0).toUpperCase() : ""
      }}{{ value.lastName ? value.lastName.charAt(0).toUpperCase() : "" }}</span
    >
  </v-avatar>
</template>

<script>
import {defineComponent} from "vue"

export default defineComponent({
  name: "TcnAuUserAvatar",
  props: {
    value: Object,
    imageUrl: null
  },
  data() {
    return {}
  },
  computed: {
    imageAvatar() {
      return this.imageUrl !== null
    },
    textSize() {
      if (!("size" in this.$attrs)) return 16
      const size = parseInt(this.$attrs.size)
      if (size != size) return 16
      return Math.ceil(size * 7 / 16)
    }
  },
  methods: {
    generateColorBasedOnId(userId) {
      let hash = 0
      for (let i = 0; i < userId.length; i++) {
        hash = userId.charCodeAt(i) + ((hash << 5) - hash)
      }
      let colour = "#"
      for (let i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xff
        colour += ("00" + value.toString(16)).substr(-2)
      }
      return colour
    },
  },
})
</script>

<style lang="scss" scoped></style>
